(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learnerSelect", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/assignments/path/steps/selectAssignTo/personSelectView.html",
            controller: ["authService", "frameworkService", "$compile", "$localStorage", "$sessionStorage", "$timeout", "$scope", "$state", "$translate", "DTOptionsBuilder", "_", LearnerSelectCtrl],
            controllerAs: "vm"
        };
        function LearnerSelectCtrl(authService, frameworkService, $compile, $localStorage, $sessionStorage, $timeout, $scope, $state, $translate, DTOptionsBuilder, _) {
            var vm = this;
            $scope.$parent.vm.stepIsValid = false;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.hasGroups = frameworkService.data.tenant.hasGroups;
            vm.organizationEnabled = frameworkService.data.tenantFeatures.organization;
            var selectAllHtml = "<pretty-checkbox ng-click='vm.updateAllCheckBoxes()' label='false' ng-model='vm.selectAll' class='pretty-checkbox-table clearfix'></pretty-checkbox>";
            vm.dtInstance = {};
            if (!$scope.$parent.vm.loadedStep2) {
                vm.selectedRows = {};
            }
            else {
                vm.selectedRows = {};
                _.map($scope.$parent.vm.learners, function (item) {
                    vm.selectedRows[item.item.personSeq] = { "item": item.item, "status": item.status };
                    return item;
                });
                vm.selectAll = $scope.$parent.vm.areAllLearnersChecked;
                //vm.dtInstance = vm.dtLearnerInstance;
            }
            //Function to determine if the form is valid
            vm.isValid = function () {
                var list = _.where(vm.selectedRows, { status: true });
                if (list.length !== 0) {
                    $scope.$parent.vm.stepIsValid = true;
                    $scope.$parent.vm.learners = list;
                    $scope.$parent.vm.selectionError = "";
                }
                else {
                    if ($scope.$parent !== null) {
                        $scope.$parent.vm.stepIsValid = false;
                        $scope.$parent.vm.selectionError = "assignments.assignPathToLearner.error.selectLearner";
                    }
                }
            };
            //click event for the select all check box:
            //updates the internal datastructure vm.selectedRows
            //with the new value
            vm.updateAllCheckBoxes = function () {
                for (var id in vm.selectedRows) {
                    if (vm.selectedRows.hasOwnProperty(id)) {
                        if ($("#" + id).is(":visible")) {
                            vm.selectedRows[id]["status"] = vm.selectAll;
                        }
                    }
                }
                vm.isValid();
            };
            //This the click event on the check box of a single row
            //If any of the rows is NOT checked then set the select all
            //model (vm.selectAll) to false; otherwise set it to true
            vm.itemChecked = function () {
                var items = _.where(vm.selectedRows, { status: false });
                vm.selectAll = items.length < 1;
                vm.isValid();
                //$scope.$apply();
            };
            if ($sessionStorage.assignLearnersFilters2) {
                vm.filters = $sessionStorage.assignLearnersFilters2;
            }
            else {
                vm.filters = {
                    firstName: { enabled: true, value: "" },
                    lastName: { enabled: true, value: "" },
                    groups: { enabled: true, value: "" }
                };
                $sessionStorage.assignLearnersFilters2 = vm.filters;
            }
            vm.resetTheSelectedRows = function () {
                for (var key in vm.selectedRows) {
                    if (vm.selectedRows.hasOwnProperty(key)) {
                        vm.selectedRows[key]["status"] = false;
                    }
                }
                vm.selectAll = false; //clear the select all check box
                $scope.$apply();
            };
            function rowCallback(nRow, data) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.jqControl)", nRow).unbind("click");
                $("td:not(.jqControl)", nRow).bind("click", function (e) {
                    var element = $(e.target);
                    element.bind("click", vm.rowClicked(data));
                });
                return nRow;
            }
            vm.rowClicked = function (learner) {
                $("#" + learner.personSeq).click();
            };
            function reloadDataCallback(json) {
                vm.selectedRows = {};
                for (var index in json.data) {
                    if (json.data.hasOwnProperty(index)) {
                        vm.selectedRows[json.data[index]["personSeq"]] = {
                            "status": false,
                            "item": json.data[index]
                        };
                    }
                }
                vm.selectAll = false; //clear the select all check box
                $scope.$apply();
            }
            vm.reloadTable = function () {
                $timeout(function () {
                    $sessionStorage.assignLearnersFilters2 = vm.filters;
                    vm.dtInstance.reloadData(reloadDataCallback, true);
                });
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.assignLearnersFilters2 = vm.filters;
                // reload only if filtered
                if (value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                vm.refreshFilter(vm.filters[filter].value);
            };
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "/api/accountSearch/assignPathToLearnerLearnersListViewModel",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "GET",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[1].search.value = vm.filters.firstName.enabled ? vm.filters.firstName.value : "";
                    data.columns[2].search.value = vm.filters.lastName.enabled ? vm.filters.lastName.value : "";
                    data.columns[3].search.value = vm.filters.groups.enabled ? vm.filters.groups.value : "";
                    data.columns[4].search.value = "";
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("rowCallback", rowCallback)
                .withOption("order", [1, "asc"])
                .withOption("createdRow", function (row, obj) {
                angular.element(row).attr("ng-class", "{selectedRow: vm.selectedRows['" + obj.personSeq + "']['status']}");
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row))($scope);
                //$compile(angular.element(row).contents())($scope);
            })
                .withOption("headerCallback", function (header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
                .withOption("fnDrawCallback", function () {
                //vm.dtInstance.DataTable.column(3).visible = vm.organizationEnabled;
                //vm.dtInstance.DataTable.column(4).visible = vm.hasGroups;
                vm.isValid();
                // if vm.learnersSelected is true means previous button press on step 3
                // This will prevent the initial previous button load from clearing selection
                if ($scope.$parent !== null) {
                    if (!$scope.$parent.vm.loadedStep2) {
                        $timeout(function () {
                            vm.resetTheSelectedRows();
                        });
                    }
                    else {
                        $scope.$parent.vm.loadedStep2 = false;
                    }
                }
            })
                .withPaginationType("full_numbers")
                .withBootstrap();
            vm.dtColumns = [
                {
                    "data": "isChecked",
                    "render": function (_data, _type, full) {
                        if (!vm.selectedRows[full.personSeq]) {
                            vm.selectedRows[full.personSeq] = { 'status': false, 'item': full };
                        }
                        return "<pretty-checkbox name='checkBox' label='false' id='" + full.personSeq + "' ng-model=vm.selectedRows['" + full.personSeq + "']['status'] ng-click='vm.itemChecked()' class='pretty-checkbox-table clearfix'></pretty-checkbox>";
                    },
                    "sortable": false,
                    "title": selectAllHtml,
                    "class": "w-10 jqControl"
                },
                {
                    "data": "firstName",
                    "title": $translate.instant("common.lists.learner"),
                    "render": function (_data, _type, full) {
                        return full.lastName + ', ' + full.firstName + " (" + full.personSeq + ")";
                    }
                },
                {
                    "data": "lastName", "visible": false
                },
                {
                    "data": "email",
                    "sortable": false,
                    "title": $translate.instant("common.lists.email")
                },
                { "data": "organization", "sortable": false, "title": $translate.instant("common.lists.organization"), "visible": vm.organizationEnabled },
                { "data": "groups", "sortable": false, "title": $translate.instant("common.lists.groups"), "visible": vm.hasGroups }
            ];
        }
    });
}());
